module.exports = __webpack_public_path__ + "img/u9.15101086.png";